import { gql, TypedDocumentNode } from '@apollo/client';
import {
  RevokeDowntimeMutation,
  RevokeDowntimeMutationVariables,
  RevokeLegacyDowntimeMutation,
  RevokeLegacyDowntimeMutationVariables,
  SetDowntimeMutation,
  SetDowntimeMutationVariables,
  SetLegacyDowntimeMutation,
  SetLegacyDowntimeMutationVariables,
} from 'generated/graphql';

export const setLegacyDowntimeMutation: TypedDocumentNode<
  SetLegacyDowntimeMutation,
  SetLegacyDowntimeMutationVariables
> = gql`
  mutation setLegacyDowntime($marketLocationId: ID!, $deviceNumber: ID!, $from: DateTime!, $to: DateTime!) {
    setLegacyDowntime(marketLocationId: $marketLocationId, deviceNumber: $deviceNumber, from: $from, to: $to) {
      setLegacyDowntime {
        entityType
        resolution
        timeSlices {
          timestamp
          entities {
            number
            datapoints {
              type
              value
            }
          }
        }
        type
      }
    }
  }
`;

export const setDowntimeMutation: TypedDocumentNode<SetDowntimeMutation, SetDowntimeMutationVariables> = gql`
  mutation setDowntime($deviceNumber: ID!, $from: DateTime!, $to: DateTime!) {
    setDowntime(deviceNumber: $deviceNumber, from: $from, to: $to)
  }
`;

export const revokeLegacyDowntimeMutation: TypedDocumentNode<
  RevokeLegacyDowntimeMutation,
  RevokeLegacyDowntimeMutationVariables
> = gql`
  mutation RevokeLegacyDowntime($deviceNumber: String!, $from: DateTime!, $to: DateTime!) {
    revokeLegacyDowntime(deviceNumber: $deviceNumber, from: $from, to: $to) {
      revokeLegacyDowntime {
        entityType
        resolution
        timeSlices {
          timestamp
          entities {
            number
            datapoints {
              type
              value
            }
          }
        }
        type
      }
    }
  }
`;

export const revokeDowntimeMutation: TypedDocumentNode<RevokeDowntimeMutation, RevokeDowntimeMutationVariables> = gql`
  mutation revokeDowntime($deviceNumber: ID!, $from: DateTime!, $to: DateTime!) {
    revokeDowntime(deviceNumber: $deviceNumber, from: $from, to: $to)
  }
`;
